/* eslint-disable */
import {
  Form,
  Button,
  Checkbox,
  Flex,
  Tabs,
  Popover,
  Radio,
  Space,
  message,
} from "antd";
import React, { useEffect, useState, useRef } from "react";
import {
  CaretDownOutlined,
  OneToOneOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import commonFn from "@/utils/commonFn";
import ReadyToPayTable from "./component/ReadyToPayTable";
import PaymentsTable from "./component/PaymentsTable";

export default function MaintenancePayContractor() {
  const [selectedItems, setSelectedItems] = useState([]);
  const [options, setOptions] = useState([]);
  const childRef = useRef();
  const [activeTab, setActiveTab] = useState("readytopay");
  const [refreshKey, setRefreshKey] = useState(0);

  // 列配置（从子组件获取）
  const [columnsConfig, setColumnsConfig] = useState([]);

  const showModalThree = () => {
    setRefreshKey(prev => prev + 1);
  };

  const handleChange = (checkedValues) => {
    setSelectedItems(checkedValues);
    if (childRef.current) {
      childRef.current.toggleColumnVisibility(checkedValues);
    }
  };

  // Popover 的内容
  const content = (
    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <Checkbox.Group
        options={options}
        value={selectedItems}
        className="checkBox"
        onChange={handleChange}
      >
        <Space direction="vertical">
          {options.map((option) => (
            <Checkbox key={option.value} value={option.value}>
              {option.label}
            </Checkbox>
          ))}
        </Space>
      </Checkbox.Group>
    </div>
  );

  const handleTabChange = (key) => {
    setActiveTab(key);
  };

  return (
    <div>
      <Flex className="topDivMain" justify="space-between" align="flex-start">
        <div>
          <Tabs
            activeKey={activeTab}
            onChange={handleTabChange}
            items={[
              { label: "Ready To Pay", key: "readytopay" },
              { label: "Payments", key: "payments" },
            ]}
          />
        </div>
        <div>
          <Radio.Group defaultValue="a" size="middle">
            <Radio.Button value="a" onClick={showModalThree}>
              <SyncOutlined />
            </Radio.Button>
            <Radio.Button value="b">
              <Popover content={content} title="" trigger="click">
                <OneToOneOutlined />
                <CaretDownOutlined className="ft12" />
              </Popover>
            </Radio.Button>
          </Radio.Group>
        </div>
      </Flex>

      {/* Ready To Pay 表格 */}
      {activeTab === "readytopay" && (
        <ReadyToPayTable refreshKey={refreshKey} />
      )}

      {/* Payments 表格 */}
      {activeTab === "payments" && (
        <PaymentsTable refreshKey={refreshKey} />
      )}
    </div>
  );
}